<template>
  <div id="app">
    <!-- 斜向天光带：参考稿中大面积的淡蓝高光 -->
    <div class="sky-beam sky-beam-one"></div>
    <div class="sky-beam sky-beam-two"></div>

    <!-- 柔和漫射光晕 -->
    <div class="ambient-glow ambient-glow-top"></div>
    <div class="ambient-glow ambient-glow-bottom"></div>
    <div class="ambient-glow ambient-glow-gold"></div>

    <!-- 漂浮的彩色光点：呼应参考稿的金币与橙黄 3D 装饰 -->
    <div class="ambient-dot dot-blue"></div>
    <div class="ambient-dot dot-gold"></div>
    <div class="ambient-dot dot-coral"></div>

    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', 'PingFang SC', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ink-main);
  background-color: var(--sky-bg-top);
  background-image:
    radial-gradient(ellipse 85% 34% at 12% 2%, rgba(255, 255, 255, 0.95) 0%, rgba(226, 239, 255, 0.5) 55%, transparent 80%),
    radial-gradient(ellipse 70% 30% at 95% 92%, rgba(198, 221, 255, 0.45) 0%, transparent 78%),
    var(--gradient-bg);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 60px rgba(43, 91, 255, 0.07);
}

/* 斜向天光：轻盈、无纹理的玻璃高光 */
.sky-beam {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  transform: rotate(-24deg);
  transform-origin: center;
  border-radius: 50%;
  filter: blur(30px);
}

.sky-beam-one {
  top: -12%;
  left: -30%;
  width: 78%;
  height: 62%;
  max-width: 420px;
  background: linear-gradient(120deg, rgba(255, 255, 255, 0.95) 0%, rgba(197, 223, 255, 0.42) 55%, transparent 100%);
}

.sky-beam-two {
  top: 46%;
  right: -38%;
  width: 76%;
  height: 48%;
  max-width: 400px;
  background: linear-gradient(120deg, rgba(255, 255, 255, 0.7) 0%, rgba(176, 208, 255, 0.35) 60%, transparent 100%);
  filter: blur(42px);
}

/* 顶部 / 底部冷色光晕与右上暖金光晕 */
.ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(52px);
}

.ambient-glow-top {
  top: -140px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 280px;
  background: radial-gradient(circle, rgba(165, 200, 255, 0.5) 0%, rgba(210, 230, 255, 0.28) 48%, transparent 74%);
}

.ambient-glow-bottom {
  bottom: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 420px;
  height: 260px;
  background: radial-gradient(circle, rgba(150, 188, 255, 0.34) 0%, rgba(216, 232, 255, 0.2) 52%, transparent 76%);
}

.ambient-glow-gold {
  top: 148px;
  right: calc(50% - 330px);
  width: 210px;
  height: 210px;
  filter: blur(44px);
  background: radial-gradient(circle, rgba(255, 214, 120, 0.34) 0%, rgba(255, 190, 96, 0.14) 48%, transparent 74%);
}

/* 漂浮光点 */
.ambient-dot {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(10px);
  opacity: 0.55;
}

.dot-blue {
  top: 30%;
  left: -14px;
  width: 46px;
  height: 46px;
  background: radial-gradient(circle at 32% 28%, rgba(255, 255, 255, 0.9), rgba(122, 168, 255, 0.65) 46%, rgba(70, 120, 240, 0.2) 72%);
}

.dot-gold {
  top: 58%;
  right: -12px;
  width: 52px;
  height: 52px;
  background: radial-gradient(circle at 32% 28%, rgba(255, 245, 205, 0.95), rgba(255, 201, 60, 0.7) 48%, rgba(245, 166, 35, 0.2) 74%);
}

.dot-coral {
  bottom: 18%;
  left: 6%;
  width: 34px;
  height: 34px;
  background: radial-gradient(circle at 32% 28%, rgba(255, 224, 205, 0.9), rgba(255, 122, 89, 0.5) 52%, transparent 76%);
  opacity: 0.4;
}

/* 宽屏预览时让漂浮光点贴合 500px 应用容器边缘 */
@media (min-width: 500px) {
  .dot-blue { left: calc(50% - 264px); }
  .dot-gold { right: calc(50% - 262px); }
  .dot-coral { left: calc(50% - 230px); }
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
